module.exports = __webpack_public_path__ + "img/stock3.8506c25c.png";